import { fetchJSON, POST, fetchPublicJSON } from 'utils/http';
import { SAVE_SA_PROFILE,
    GET_SA_PROFILE,
    ADD_SA_PROFILE_VIDEO,
    SA_PROFILE_SCHOOLS,
    UPDATE_SA_PROFILE,
    GET_ATHLETE_BY_ID,
    GET_ATHLETE_FOR_COACH_BY_ID,
    GET_REQUEST_BY_ID,
    DELETE_ATHLETE_VIDEO_BY_INDEX,
    UPDATE_STUDENT_TRIAL,
} from 'constants/urls';

export function saveProfile(profile, id) {
  if (id === 'PENDING') { return fetchJSON(SAVE_SA_PROFILE, POST, {}, profile, {}); }
  return fetchJSON(UPDATE_SA_PROFILE, POST, {}, profile, {});
}

export function getProfile(id) {
  return fetchJSON(GET_SA_PROFILE + id);
}

export function saveProfileVideo(video) {
  return fetchJSON(ADD_SA_PROFILE_VIDEO, POST, {}, video, {});
}

export function searchSchoolsByName(query) {
  return fetchJSON(SA_PROFILE_SCHOOLS, POST, {}, query, {});
}

export function getPublicProfile(id) {
  return fetchPublicJSON(GET_ATHLETE_BY_ID + id);
}

export function getPublicProfileForCoach(id) {
  return fetchPublicJSON(GET_ATHLETE_FOR_COACH_BY_ID + id);
}

export function getPublicRequestById(id) {
  return fetchPublicJSON(GET_REQUEST_BY_ID + id);
}

export function removeVideoById(data) {
  return fetchJSON(DELETE_ATHLETE_VIDEO_BY_INDEX, POST, {}, data, {});
}

export function startTrial(data) {
  return fetchJSON(UPDATE_STUDENT_TRIAL, POST, {}, data, {});
}




// WEBPACK FOOTER //
// ./src/common/services/saProfile.service/saProfile.service.js